import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShaderEffect: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconShaderEffect"><Path d="M20.5 3.5H3.5V20.5H20.5V3.5Z" stroke="currentColor"/><Path d="M4 20L20 4" stroke="currentColor"/><Path d="M3.5 12.5L12.5 3.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconShaderEffect;
